@if (currentIcon$ | async; as currentIcon) {
  <nk-flag-icon
    class="align-middle d-inline-block {{
      companyFlagCategoryColor() ? 'pb-1 rounded bg-' + companyFlagCategoryColor() : ''
    }}"
    [appIcon]="currentIcon"
    [size]="size()"
    [andClass]="andClass()"
    [colorClassOverride]="colorClassOverride()"></nk-flag-icon>
}
